import { createStyles } from 'antd-style';

export default createStyles(({ css }) => ({
  // Loading state styles
  loadingContainer: css`
    text-align: center;
    padding: 20px;
  `,

  // Delete button styles
  deleteButton: css`
    min-width: auto;
  `,

  // Preview modal styles
  previewModal: css`
    height: 90vh !important;
  `,

  // Markdown preview container styles
  markdownPreviewContainer: css`
    height: 100%;
    overflow: auto;
    padding: 16px;
  `,

  // Preview image styles
  previewImage: css`
    width: 100%;
  `,
}));
